import React, { useState, useRef, useEffect } from "react";
import FormValidate from "../../common/FormValidate";
import { useHistory, NavLink } from "react-router-dom";
import { Grid, Image, Loader, Input, Popup, Icon } from "semantic-ui-react";
import atar_logo from "../../assets/home/atar_logo.png";
import info from "../../assets/home/profile-gold.svg";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import profile_img from "../../assets/home/profile.png";
import { uploadImgApi } from "../../utility/site-apis";
import { useSelector, useDispatch } from 'react-redux'
import { setUpdateUserSucces, updateUser } from '../../store/UserRedux'
import { useTranslation } from "react-i18next";
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { StarButton, Loading } from '../../components'

const Profile = () => {
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const userDetails = useSelector((state) => state.user.userDetails)
  const isFetching = useSelector((state) => state.user.isFetching)
  const updateUserSuccess = useSelector((state) => state.user.updateUserSuccess)
  const { t, i18n } = useTranslation();


  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const fullnameRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();
  const [loader, setLoader] = useState(false);
  const [active, setActive] = useState(false);
  const history = useHistory();

  const [states, setStates] = useState({
    fullname: "",
    profileURL: "",
    aadhaarCardFront: "",
    aadhaarCardBack: "",
    dob: null,
    phone: "",
    email: "",
  });

  const [errors, setErrors] = useState({
    fullname: null,
    profileURL: null,
    aadhaarCardFront: null,
    aadhaarCardBack: null,
    dob: null,
    phone: null,
    email: null,
  });

  const inputChange = (key, value) => {
    setStates({ ...states, [key]: (value.target.value).trimStart() });
    setErrors({ ...errors, [key]: null });
    setActive(true);
  };

  const onFileChange = async (key, event) => {
    window.scrollTo(0, 0)
    setLoader(true)
    let data = await uploadImgApi(event.target.files[0], token);
    if (data) {
      setStates({ ...states, [key]: data });
      setActive(true);
    }
    setLoader(false)
  };

  useEffect(() => {
    if (active && updateUserSuccess) {
      dispatch(setUpdateUserSucces(false))
      history.push("/");
    }
  }, [updateUserSuccess]);

  useEffect(() => {
    if (userDetails) {
      setStates({
        fullname: userDetails?.profile?.name,
        profileURL: userDetails?.profile?.profileURL,
        aadhaarCardFront: userDetails?.aadhaarCardFront,
        aadhaarCardBack: userDetails?.aadhaarCardBack,
        dob: userDetails.dob ? new Date(userDetails.dob) : null,
        phone: userDetails.phone,
        email: userDetails.email,
      });
    }
  }, [userDetails]);

  const formsubmit = () => {
    let errors = {}
    if (!states.fullname) {
      fullnameRef.current.focus();
      errors['fullname'] = "Add Your Name"
    }
    if (states.fullname && !FormValidate.isName(states.fullname)) {
      errors['fullname'] = 'Please enter a valid Name'
    }
    if (!states.dob) {
      errors['dob'] = "Add Your Date of Birth"
    }
    if (!FormValidate.isPhone(states.phone)) {
      errors['phone'] = "Add Your Phone Number"
    }
    if (!FormValidate.isEmail(states.email)) {
      errors['email'] = "Add Your Email Address"
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors)
      return
    }

    states.name = states.fullname
    states._id = userDetails._id
    states.token = token
    if (active) {
      dispatch(updateUser(states))
    }
  };

  return (
    <div className="container_bg clearall">
      <NavLink
        to="">
        <Image className="pro-logo_img" src={atar_logo} />
      </NavLink>

      <div className="inner_bg2">
        <div className="heading_sec">
          <h2>{t("profile.titel")}</h2>
          <h4>{t("profile.para")}</h4>
          {loader && (<Loading />)}
          <div
            style={{
              textAlign: "center",
              position: "relative",
              width: 100,
              margin: "0 auto",
            }}
          >
            <Image
              style={{ maxWidth: 100, height: 100, }}
              src={states.profileURL ? states.profileURL : profile_img}
              className="profile-input-img"
            />
            <input
              type="file"
              id="upload"
              hidden
              onChange={(val) => onFileChange("profileURL", val)}
            />
            <label className="editicon" for="upload">
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </label>
          </div>
        </div>
        <h3 className="files">
          {t("profile.basic")}
          {/* BASIC DETAILS */}
        </h3>

        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <Input
                className="profile_input"
                placeholder="Full Name"
                ref={fullnameRef}
                value={states.fullname}
                onChange={(val) => inputChange("fullname", val)}
              />
              {errors.fullname && <div className="erro">{errors.fullname}</div>}
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={8}>

              <DatePicker
                className="inputdata"
                maxDate={moment.utc().toDate()}
                placeholderText="Date of Birth ( DD/MM/YY )"
                dateFormat="dd/MM/yyyy"
                selected={states.dob}
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                onChange={(date) => {
                  setStates({ ...states, dob: date });
                  setErrors({ ...errors, dob: null });
                }}
              />

              {errors.dob && <div className="erro date-picker">{errors.dob}</div>}
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <Input
                readOnly={true}
                className="profile_input"
                placeholder="Phone Number"
                ref={phoneRef}
                value={states.phone}
                onChange={(val) => inputChange("phone", val)}
              />
              {errors.phone && <div className="erro">{errors.phone}</div>}
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <Input
                className="profile_input"
                placeholder="Email Address"
                ref={emailRef}
                value={states.email}
                onChange={(val) => inputChange("email", val)}
              />
              {errors.email && <div className="erro">{errors.email}</div>}
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid centered divided="vertically">
          <h3 className="files basic-info "  >
            {t("profile.upload")}
            {/* UPLOAD FILES */}
          </h3>
          <span data-inverted="true" className='popup-span' >
            <Popup content='Adhar card help to verify you details please provide us the Adhar card images
'            trigger={<img src={info} />} />
          </span>

          <Grid divided="vertically">
            <Grid.Row columns={2} className="upload-wrapper" >
              <Grid.Column mobile={16} tablet={8} computer={8}>
                {states.aadhaarCardFront ? (
                  <div className="upload_sec">
                    <Image src={states.aadhaarCardFront} />
                    <input
                      type="file"
                      id="upload2"
                      hidden
                      onChange={(val) => onFileChange("aadhaarCardFront", val)}
                    />
                    {userDetails && !userDetails.verified && (<label className="editimg" for="upload2">
                      <i className="fa fa-pencil" aria-hidden="true"></i>
                    </label>)}
                  </div>
                ) : (
                  <div className="upload_sec">
                    <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                    <h6>
                      {t("profile.para1")} <span>{t("profile.front")}</span> {t("profile.para2")}
                    </h6>
                    <input
                      type="file"
                      id="upload22"
                      hidden
                      onChange={(val) => onFileChange("aadhaarCardFront", val)}
                    />
                    <label className="click" for="upload22">
                      {t("profile.btn")}
                    </label>
                  </div>
                )}
              </Grid.Column>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                {states.aadhaarCardBack ? (
                  <div className="upload_sec">
                    <Image src={states.aadhaarCardBack} />
                    <input
                      type="file"
                      id="upload3"
                      hidden
                      onChange={(val) => onFileChange("aadhaarCardBack", val)}
                    />
                    {userDetails && !userDetails.verified && (<label className="editimg" for="upload3">
                      <i className="fa fa-pencil" aria-hidden="true"></i>
                    </label>)}
                  </div>
                ) : (
                  <div className="upload_sec">
                    <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                    <h6>
                      {t("profile.para1")} <span> {t("profile.back")}</span>  {t("profile.para2")}
                    </h6>
                    <input
                      type="file"
                      id="upload33"
                      hidden
                      onChange={(val) => onFileChange("aadhaarCardBack", val)}
                    />
                    <label className="click" for="upload33">
                      {t("profile.btn")}
                    </label>
                  </div>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {isFetching && (
            <div style={{ width: "100%" }}>
              <Loader active inline="centered" />
            </div>
          )}
          <div className="clearall profileButton">
            <StarButton background={'mainBg'} title={t("profile.btn1")} onClickAction={formsubmit} disableStar={active ? false : true} isGray={active ? false : true} />
          </div>
        </Grid>
      </div>
    </div>
  );
};

export default Profile
